import styled from 'styled-components'

export const ReplyBoxStyled = styled.div`
  padding-top: 8px;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.03);

  .ant-form-item {
    margin-bottom: 0;
  }

  .ant-input-textarea {
    &:hover,
    &:focus {
      border-color: #1890ff;
    }
  }

  .ant-btn-text {
    &:hover {
      background: #f0f0f0;
    }
  }
`
